/** Membership and form limits shared by the client and server. */
export const FAMILY_MEMBER_LIMIT = 6;
export const FAMILY_NAME_MAX_LENGTH = 80;
export const FAMILY_DISPLAY_NAME_MAX_LENGTH = 40;
export const CODE_GROUP_LENGTH = 4;
export const FAMILY_CODE_LENGTH = CODE_GROUP_LENGTH * 2;
export const FAMILY_FORMATTED_CODE_LENGTH = FAMILY_CODE_LENGTH + 1;

export const FAMILY_LIMIT = FAMILY_MEMBER_LIMIT;
export const FAMILY_LIVE_INVITE_LIMIT = 5;
export const FAMILY_LINK_TOKEN_MAX_LENGTH = 256;
export function formatFamilyCode(code: string): string {
  const raw = code.replace(/-/g, '');
  return `${raw.slice(0, CODE_GROUP_LENGTH)}-${raw.slice(CODE_GROUP_LENGTH)}`;
}

/** One seat-exhaustion sentence for plan, agent and upload surfaces. */
export function familyAiSeatsFullCopy(until: string | null): string {
  const words: Readonly<Record<number, string>> = { 6: "six" };
  const count = words[FAMILY_MEMBER_LIMIT] ?? String(FAMILY_MEMBER_LIMIT);
  return `Your family's ${count} AI seats are in use${until ? ` until ${until}` : ""}.`;
}
